import React, { useContext } from "react";
import { CreateArtifactContext } from "../../../../../context/CreateArtifactContext";
import { ContentState } from "../../../../../models/SKArtifact";
import { normalizeURL } from "../../../../../utils/stringFunctions";

interface Item {
  id: string;
  listImage: string;
  listTitle: string;
  listURL: string;
}

interface LayoutGridInputProps {
  items: Item[];
  editItemPopup: (id: string) => void;
  handleRemoveItem: (id: string) => void;
}

export const LayoutGridInput = ({ items, editItemPopup, handleRemoveItem }: LayoutGridInputProps) => {
  const { isEditable } = useContext(CreateArtifactContext);
  return (
    <div className="grid grid-cols-2 gap-[15px] w-full">
      {items.map((item, index) => (
        <div key={index} className=" border-skseparatorgray rounded-md p-[15px] flex flex-col">
          <div className="flex flex-col gap-[15px]">
            <div className="flex flex-row gap-[5px]">
              <div className="flex items-center justify-center">
                <div className="relative border-2 border-gray-200 w-[200px] h-[200px] max-w-[290px] max-h-[200px] rounded-md overflow-hidden">
                  <img src={item.listImage} alt={item.listTitle} className="object-cover w-full h-auto" />
                </div>
              </div>
              <div className="flex max-w-[150px] ml-auto">
                {isEditable && (
                  <div className="flex flex-col gap-2">
                    <button
                      className="flex items-center justify-center w-5 h-5 text-white rounded-full shadow-md bg-slate-600 max-h-8 max-w-8"
                      onClick={() => handleRemoveItem(item.id)}
                    >
                      ×
                    </button>
                    <button
                      className="flex items-center justify-center w-5 h-5 text-white rounded-full shadow-md bg-slate-600 max-h-8 max-w-8"
                      onClick={() => editItemPopup(item.id)}
                    >
                      ✎
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className="flex flex-col justify-start">
              <div className="list_item_title">{item.listTitle}</div>
              <div className="list_item_sub_title">
                <a
                  href={normalizeURL(item.listURL)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-500 underline hover:text-gray-700"
                >
                  {item.listURL}
                </a>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
